import React from 'react';

const Footer = () => {
  return (
    <footer
      className="main-footer"
      style={{
        textAlign: 'center',       // centers text horizontally
          // optional: adds some vertical space
      
      }}
    >
      © 2026 and beyond <a href="#">Bindi International</a>. All Rights Reserved.
    </footer>
  );
};

export default Footer;
